import { Ref } from '@nuxtjs/composition-api'

export interface PartnerSuggestions {
  deposit?: number
  interest: number
  period: number
}
export interface LoanCalculatorPartner {
  value: string
  description: string
  period: string
  interest: string
}

export interface PaymentPartner {
  down_payment: number
  external_url: boolean
  front_page: boolean
  id: number
  interest_rate: number
  loan_calculator: boolean
  logo: string
  partner_name: string
  period: number
  url: string
  __typename: string
}

export interface PaymentPartners {
  items: PaymentPartner[]
  __typename: string
}

export interface InstallmentCalculatorStore {
  data: Ref<PaymentPartner[]>
  fetch(force?: boolean): Promise<PaymentPartner[]>
}

export interface UseInstallmentCalculator extends InstallmentCalculatorStore {
  periodConfig: CalculatorSliderConfig
  generatePeriodItems(): CalculatorItem[]
  depositConfig: CalculatorSliderConfig
  generateDepositItems(price: number): CalculatorItem[]
  interestConfig: CalculatorSliderConfig
  generateInterestItems(): CalculatorItem[]
  calculateMinMonthlyPayment(price: number): number
  getMonthlyPayment (price: number, partner: PartnerSuggestions): number
}

export interface CalculatorItem {
  value: string | number
  description?: string
}

export interface CalculatorSliderRange {
  min: number
  max: number
}

export interface CalculatorSliderConfig {
  start: number
  range: CalculatorSliderRange
  step: number
}

export interface Slider {
  value: CalculatorItem
  title: string
  placeholder: string
  unit: string
  config: CalculatorSliderConfig
  selectorItems: CalculatorItem[]
}

export enum SliderItem {
  PERIOD = 'Period',
  INTEREST = 'Interest rate',
  DEPOSIT = 'Deposit'
}
